import React from "react";
import { Checkbox } from "antd";
import AppInput from "./AppInput";
import { localLogDateTime } from "../utils/logDateTime";

export default function LogDateTimeInput({ value, onChange, captureNow, onCaptureChange, disabled = false, min, error }) {
  return <>
    <AppInput type="datetime-local" label="Date & Time" value={localLogDateTime(value)}
      onChange={(event) => onChange(event.target.value)} disabled={disabled || captureNow}
      min={min ? localLogDateTime(min) : undefined} max={localLogDateTime()} errors={error} />
    <Checkbox checked={captureNow} disabled={disabled} onChange={(event) => {
      onCaptureChange(event.target.checked);
      if (event.target.checked) onChange(localLogDateTime());
    }}>Capture current date/time when saving</Checkbox>
  </>;
}
